export const dateToString = (dateStr: string): string => {
  const originalDate = new Date(dateStr);

  if (Number.isNaN(originalDate.getTime())) {
    return "invalid date";
  }

  const jstTimeMillis = originalDate.getTime() + 9 * 60 * 60 * 1000;
  const jstDate = new Date(jstTimeMillis);

  const year = jstDate.getUTCFullYear();
  const month = jstDate.getUTCMonth() + 1;
  const day = jstDate.getUTCDate();
  const hour = jstDate.getUTCHours();
  const minute = jstDate.getUTCMinutes();

  const paddedMonth = String(month).padStart(2, "0");
  const paddedDay = String(day).padStart(2, "0");
  const paddedHour = String(hour).padStart(2, "0");
  const paddedMinute = String(minute).padStart(2, "0");

  const formattedDate = `${year}年${paddedMonth}月${paddedDay}日 ${paddedHour}:${paddedMinute}`;

  return formattedDate;
};
